import { prototype } from 'module';
<template>
  <div>
    <div class='clpp-api-name clpp-api-title' :class="{'clpp-api-deprecated': isDeprecated}">
      {{longSignature}}
<badge :label="b" v-for="b in badges" :key='b'/>
      </div>

    <div class='clpp-api-level v-space-top' v-if='nonObjectType'>
      <span class='clpp-api-label'>Type:</span> <span v-html='type'>{{type}}</span>
    </div>

    <div class='clpp-api-level v-space' v-if='isDeprecated'>
        <h4>Deprecated</h4>
        <div class='clpp-api-level'>
          <div v-html="deprecatedMessage">{{deprecatedMessage}}</div>
        </div>
    </div>

    <div class='clpp-api-level v-space-top' v-if='description'>
      <div class='clpp-api-description' v-html="description">{{description}}</div>
    </div>

    <div class='clpp-api-level' v-if='properties.length'>
      <div v-if='isEnum'>
        <div class="v-space-bottom clpp-api-prop-table">
          <table>
            <thead>
            <tr>
              <th class="name-header-column">Name</th>
              <th class="description-header-column">Description</th>
            </tr>
            </thead>
            <tbody>
            <DocsDetailParameter
              :entry='p' :parent='entry' :no-type="true"
              v-for='p in properties' :key='p.name' :id='p.name'/>
            </tbody>
          </table>
        </div>
      </div>
      <div v-else class="v-space-top">
        <h4>Properties</h4>
        <div class="clpp-api-level v-space-bottom clpp-api-prop-table" >
          <table class="">
            <thead>
            <tr>
              <th class="name-header-column">Name</th>
              <th class="type-header-column">Type</th>
              <th class="description-header-column" width="100%">Description</th>
            </tr>
            </thead>
            <tbody>
              <DocsDetailParameter v-for='p in properties' :key='p.name' :entry='p' :parent='entry'/>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <div class='clpp-api-level' v-if='parameters.length'>
      <h3>Parameters</h3>
      <div class="clpp-api-level clpp-api-prop-table">
        <table>
          <thead>
          <tr>
            <th class="name-header-column">Name</th>
            <th class="type-header-column">Type</th>
            <th class="description-header-column" width="100%">Description</th>
          </tr>
          </thead>
          <tbody>
            <DocsDetailParameter :entry='p' :parent='entry' v-for='p in parameters' :key='p.name' :id='p.name'/>
          </tbody>
        </table>
      </div>
    </div>

    <div class='clpp-api-level' v-if='returns.length'>
      <h3>Returns</h3>
      <div class='clpp-api-level'>
        <DocsDetailReturns v-for='p in returns' :key='p.___id' :entry='p'/>
      </div>
    </div>

    <div class='clpp-api-level v-space-top' v-if='examples.length'>
      <h3>Examples</h3>
      <div class='clpp-api-level'>
        <DocsDetailExample v-for='p in examples' :key='p.___id' :entry='entry' :example='p'/>
      </div>
    </div>

  </div>
</template>

<script>
import { DocsComponentMixin } from '../../utils/docs';
import DocsDetailParameter from './DocsDetailParameter.vue';
import DocsDetailExample from './DocsDetailExample.vue';
import DocsDetailReturns from './DocsDetailReturns.vue';
import Badge from '../Badge.vue';

export default {
  mixins: [DocsComponentMixin],
  name: 'DocsDetailType',
  components: {
    DocsDetailParameter,
    DocsDetailExample,
    DocsDetailReturns,
    Badge
  },
  data () {
    return {
      needsToScroll: null
    };
  },
  created () {
    this.needsToScroll = this.$route && this.$route.hash;
  },
  mounted () {
    if (this.needsToScroll) {
      const el = document.getElementById(this.needsToScroll.substr(1));
      if (el) {
        el.scrollIntoView(true);
        this.needsToScroll = false;
      }
    }
  }

};
</script>
